/**
 * HEADER JAVASCRIPT - Extracted from header.liquid
 * Handles language switching functionality for both desktop and mobile
 */

document.addEventListener('DOMContentLoaded', function () {
    // Desktop Language Switcher Functionality - Dropdown Toggle
    const desktopLanguageToggle = document.querySelector('[data-desktop-language-toggle]');
    const desktopLanguageDropdown = document.querySelector('[data-desktop-language-dropdown]');

    if (desktopLanguageToggle && desktopLanguageDropdown) {
        console.log('Desktop language switcher initialized');

        // Handle desktop language toggle click
        desktopLanguageToggle.addEventListener('click', function (e) {
            e.preventDefault();
            e.stopPropagation();

            // Position dropdown directly under the globe icon
            const toggleRect = desktopLanguageToggle.getBoundingClientRect();
            desktopLanguageDropdown.style.top = (toggleRect.bottom + 4) + 'px';
            desktopLanguageDropdown.style.left = toggleRect.left + 'px';
            desktopLanguageDropdown.style.right = 'auto';

            // Toggle dropdown
            desktopLanguageDropdown.classList.toggle('is-open');
        });

        // Handle language option clicks
        const languageOptions = desktopLanguageDropdown.querySelectorAll('[data-language-url]');
        languageOptions.forEach(option => {
            option.addEventListener('click', function (e) {
                e.preventDefault();
                e.stopPropagation();

                const targetUrl = this.getAttribute('data-language-url');
                console.log('Switching to language:', targetUrl);

                // Close dropdown
                desktopLanguageDropdown.classList.remove('is-open');

                // Redirect to the new URL
                if (targetUrl && targetUrl !== window.location.href) {
                    window.location.href = targetUrl;
                }
            });
        });

        // Close dropdown when clicking outside
        document.addEventListener('click', function (e) {
            if (!desktopLanguageToggle.contains(e.target) && !desktopLanguageDropdown.contains(e.target)) {
                desktopLanguageDropdown.classList.remove('is-open');
            }
        });
    } else {
        console.log('Desktop language switcher elements not found');
    }

    // Mobile Language Switcher Functionality - Dropdown Toggle
    const mobileLanguageToggle = document.querySelector('[data-mobile-language-toggle]');
    const mobileLanguageDropdown = document.querySelector('[data-mobile-language-dropdown]');

    if (mobileLanguageToggle && mobileLanguageDropdown) {
        console.log('Mobile language switcher initialized');

        // Handle mobile language toggle click
        mobileLanguageToggle.addEventListener('click', function (e) {
            e.preventDefault();
            e.stopPropagation();

            // Position dropdown directly under the globe icon
            const toggleRect = mobileLanguageToggle.getBoundingClientRect();
            mobileLanguageDropdown.style.top = (toggleRect.bottom + 4) + 'px';
            mobileLanguageDropdown.style.left = toggleRect.left + 'px';
            mobileLanguageDropdown.style.right = 'auto';

            // Toggle dropdown
            mobileLanguageDropdown.classList.toggle('is-open');
        });

        // Handle language option clicks
        const mobileLanguageOptions = mobileLanguageDropdown.querySelectorAll('[data-language-url]');
        mobileLanguageOptions.forEach(option => {
            option.addEventListener('click', function (e) {
                e.preventDefault();
                e.stopPropagation();

                const targetUrl = this.getAttribute('data-language-url');
                console.log('Mobile switching to language:', targetUrl);

                // Close dropdown
                mobileLanguageDropdown.classList.remove('is-open');

                // Redirect to the new URL
                if (targetUrl && targetUrl !== window.location.href) {
                    window.location.href = targetUrl;
                }
            });
        });

        // Close dropdown when clicking outside
        document.addEventListener('click', function (e) {
            if (!mobileLanguageToggle.contains(e.target) && !mobileLanguageDropdown.contains(e.target)) {
                mobileLanguageDropdown.classList.remove('is-open');
            }
        });
    } else {
        console.log('Mobile language switcher elements not found');
    }
});

